export default __webpack_public_path__ + "static/media/brigitte.1123850c.webp";